'use strict';

var VideoModal = function(video_id) {

    var video_id = video_id;

	function init(video_id) {
        create_modal();
    }
    
    function create_modal() {
        var iframe = get_iframe();
        var modal = '<div class="modal"><div class="modal__background"></div><div class="close-modal-btn"><i class="fa fa-times" aria-hidden="true"></i></div>' + iframe + '</div>';
        document.body.style.overflowY = 'hidden';
        document.body.insertAdjacentHTML('afterbegin', modal);
        add_listeners();
    }

    function add_listeners() {
        $('.modal').on('click', close_modal);
        $('.modal .close-modal-btn').on('click', close_modal);
    }
    
    function get_iframe() {
        return '<div class="iframe-container"><iframe style="" src="//www.youtube.com/embed/' + video_id + '" frameborder="0" allowfullscreen></iframe></div>';
    }
    
    function close_modal() {
        $('.modal').remove();
        document.body.style.overflowY = 'visible';
    }

    init();

}

module.exports = VideoModal;